import React, { useState } from 'react';

function SimpleForm() {
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    email: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Submitted:\nName: ${formData.name}\nNumber: ${formData.number}\nEmail: ${formData.email}`);
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      
      
      <div className="mx-auto">
                    <div className="mx-auto-heading-land-3">
                        Enroll <span className="theme-red-text"> Now</span>
                    </div>
                    <div className="d-flex justify-content-center">
                        <form
                            style={{ width: "50%", maxWidth: "350px" }}
                            onSubmit={handleSubmit}
                        >
                            <div className="form-group mb-3">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>

                            <div className="form-group mb-3">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>

                            <div className="form-group mb-3">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Enter your phone number"
                                    required
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="city">City or District</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="place"
                                    value={formData.place}
                                    onChange={handleChange}
                                    placeholder="Enter your Locality"
                                    required
                                />
                            </div>



                            <div className="text-center">
                                <button type="submit" className="btn btn-danger px-4 py-2">
                                    Join Now
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
    </div>
  );
}

export default SimpleForm;
